import React, { useCallback, useState } from 'react';

import { useAppContext } from 'src/components/app-context';
import { useCampaignCardContext } from '../../campaign-card-context';

import { Direction } from '@prisjakt/ui';
import { Dropdown, DropdownContent } from '@prisjakt/ui/dropdown';
import { IconFlagOutlined } from '@prisjakt/ui/icon/flag-outlined';
import { IconMenuKebab } from '@prisjakt/ui/icon/menu-kebab';
import { ButtonSize, ButtonType } from '@prisjakt/ui/button';
import { Column } from '@prisjakt/ui/list/variants';
import { ReportModal } from 'src/areas/product/components/price-list/price-row/components/report-modal';

import { StyledActionButton, StyledListButton, StyledToggle } from './styles';

type Props = { marginRem?: number };

export const CampaignCardActionButton = (props: Props) => {
  const { marginRem = 1 } = props;
  const { image, name, price, stockStatus, store } = useCampaignCardContext();
  const { t } = useAppContext();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      setModalIsOpen(true);
    },
    [setModalIsOpen]
  );

  const closeModal = useCallback(() => setModalIsOpen(false), [setModalIsOpen]);

  return store && price ? (
    <StyledActionButton $marginRem={marginRem}>
      <ReportModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        priceId={String(price.id)}
        priceValue={price.price}
        productName={name}
        productImage={image}
        stockStatus={stockStatus}
        store={store}
        isFeatured={Boolean(store.featured)}
      />
      <Dropdown closeOnItemClick>
        <StyledToggle
          onlyIcon
          size={ButtonSize.NORMAL}
          type={ButtonType.OUTLINED}
          containerProps={{
            'aria-label': t('feedback', 'dialog.prompt-button'),
          }}
        >
          <IconMenuKebab />
        </StyledToggle>
        <DropdownContent alignment={Direction.Right}>
          <Column>
            <StyledListButton type="button" onClick={openModal}>
              <IconFlagOutlined size={15} />
              {t('feedback', 'dialog.prompt-button')}
            </StyledListButton>
          </Column>
        </DropdownContent>
      </Dropdown>
    </StyledActionButton>
  ) : null;
};
